import greenStar from './greenStar.svg';
import whiteStar from './whiteStar.svg';
import './header.css'

function Header({ name, mode }) {
  
  const star = mode === true ? greenStar : whiteStar;

  return (
    <div className="header">
      <img src={star} alt="" className='spin'/>
      <h1>{name}</h1>
      <img src={star} alt="" className='spin' />
    </div>
  );
}

export default Header;
